import { ApiService, ApiServiceInterface } from "../../../../../core";
import { PaymentOrderResponse, PaymentOrdersPageController } from "../../core";

export class PaymentOrdersPageControllerImpl implements PaymentOrdersPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<PaymentOrderResponse> {
        try {
            const response = await this.api.get('/manager-subscription-page');
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async createBankInvoice(data: FormData): Promise<PaymentOrderResponse> {
        try {
            const response = await this.api.post('/manager-bank-invoices', data);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async sendBankInvoice(data: FormData): Promise<PaymentOrderResponse> {
        try {
            const response = await this.api.post('/manager-bank-invoices-send', data);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async cancelBankInvoice(data: FormData): Promise<PaymentOrderResponse> {
        try {
            const response = await this.api.post('/manager-bank-invoices-cancel', data);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async registerPaymentBankInvoice(data: {}): Promise<PaymentOrderResponse> {
        try {
            const response = await this.api.put('/manager-bank-invoices-payment', data);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }
}